<template>
  <span
    v-tooltip.right.hover="$t(blockReasonTooltip)"
    :class="blockReasonClass"
  />
</template>

<script>
import {
  statsService,
} from '@/angularBridgeCode/ringbaPortal.servicesModule';
import sharedMessages from '@/core/locales';

export default {
  name: 'Status',
  props: {
    entity: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    blockReasonTranslation() {
      return {
        OPEN: {
          className: 'green_status',
          tooltip: 'OPEN',
          status: 'open',
        },
        CLOSED: {
          className: 'red_status',
          tooltip: 'PAUSED',
          status: 'red-disabled',
        },
        ConcurrencyHit: {
          className: 'yellow_status',
          tooltip: 'TARGETS_STATUS_CC_HIT',
          status: 'capped',
        },
        GroupConcurrencyHit: {
          className: 'yellow_status',
          tooltip: 'TARGETS_STATUS_CC_HIT_GROUP',
          status: 'capped',
        },
        IsCapped: {
          className: 'yellow_status',
          tooltip: 'TARGETS_STATUS_CAPPED',
          status: 'capped',
        },
        GroupIsCapped: {
          className: 'yellow_status',
          tooltip: 'TARGETS_STATUS_CAPPED_GROUP',
          status: 'capped',
        },
        IsClosed: {
          className: 'red_status',
          tooltip: 'TARGETS_STATUS_CLOSED',
          status: 'red-disabled',
        },
        GroupIsClosed: {
          className: 'red_status',
          tooltip: 'TARGETS_STATUS_CLOSED_GROUP',
          status: 'red-disabled',
        },
        Disabled: {
          className: 'red_status',
          tooltip: 'TARGETS_STATUS_DISABLED',
          status: 'red-disabled',
        },
        GroupDisabled: {
          className: 'red_status',
          tooltip: 'TARGETS_STATUS_DISABLED_GROUP',
          status: 'red-disabled',
        },
        BuyerConcurrencyHit: {
          className: 'yellow_status',
          tooltip: 'BUYERS_STATUS_CC_HIT',
          status: 'capped',
        },
        BuyerIsCapped: {
          className: 'yellow_status',
          tooltip: 'BUYERS_STATUS_CAPPED',
          status: 'capped',
        },
      };
    },
    blockReasonClass() {
      if (!this.entity) {
        return null;
      }

      if (this.entity.tStatus && this.entity.tStatus.uiStatus) {
        return this.entity.tStatus.uiStatus.className;
      }

      return statsService.checkBlockReason(
        this.entity,
        this.blockReasonTranslation
      ).className;
    },
    blockReasonTooltip() {
      if (!this.entity) {
        return null;
      }

      if (this.entity.tStatus && this.entity.tStatus.uiStatus) {
        return this.entity.tStatus.uiStatus.tooltip;
      }

      return statsService.checkBlockReason(
        this.entity,
        this.blockReasonTranslation
      ).tooltip;
    },
  },
  i18n: {
    sharedMessages,
    locale: 'en',
  },
};
</script>

<style>
</style>
